"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemOrdersIcon = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const iconContent = () => (react_1.default.createElement("svg", { height: 20, id: 'Layer_1', viewBox: '0 0 24 24', width: 20, x: 0, xmlSpace: 'preserve', xmlns: 'http://www.w3.org/2000/svg', y: 0 },
    react_1.default.createElement("style", null, '.st0{fill:none;stroke:#5c5f62;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'),
    react_1.default.createElement("path", { className: 'st0', d: 'M6.4 2.9v3h6v-3' }),
    react_1.default.createElement("path", { className: 'st0', d: 'M11.4 16.4h-9v-14h14v8.9' }),
    react_1.default.createElement("path", { d: 'M16.4 9.4c-3.7 0-6.8 3-6.8 6.8 0 3.7 3 6.8 6.8 6.8 3.7 0 6.8-3 6.8-6.8-.1-3.8-3.1-6.8-6.8-6.8zm-1 3.9c0-.6.4-1 1-1s1 .4 1 1v2.3c0 .6-.4 1-1 1s-1-.4-1-1v-2.3zm1 6.6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1z' })));
const ProblemOrdersIcon = () => (react_1.default.createElement(polaris_1.Icon, { accessibilityLabel: 'Problem Order', source: iconContent, tone: 'base' }));
exports.ProblemOrdersIcon = ProblemOrdersIcon;
